import { DayOfTheWeek } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

/**
 * 利用可能曜日に関する選択肢
 */
export const StayableDayOfTheWeekOptions = [
	{ id: DayOfTheWeek.Sun, label: "日曜日", value: DayOfTheWeek.Sun },
	{ id: DayOfTheWeek.Mon, label: "月曜日", value: DayOfTheWeek.Mon },
	{ id: DayOfTheWeek.Tue, label: "火曜日", value: DayOfTheWeek.Tue },
	{ id: DayOfTheWeek.Wed, label: "水曜日", value: DayOfTheWeek.Wed },
	{ id: DayOfTheWeek.Thu, label: "木曜日", value: DayOfTheWeek.Thu },
	{ id: DayOfTheWeek.Fri, label: "金曜日", value: DayOfTheWeek.Fri },
	{ id: DayOfTheWeek.Sat, label: "土曜日", value: DayOfTheWeek.Sat },
] satisfies FormOptionType[];
